/*
 * util helper methods
 */

import { ToastPlugin } from '@lx-frontend/cvux'
import Vue from 'vue'
import cookie from './cookie'
import cloneDeep from 'lodash/cloneDeep'
import forIn from 'lodash/forIn'

Vue.use(ToastPlugin)

export default {
  regexpMap: {
    regexp_mobile: /^1[3-9][0-9]{9}$/, // 手机校验
    regexp_name_cn: /^([\u4e00-\u9fa5]{2,8})$/, // 中文姓名校验
    regexp_name_en: /^([A-Z]+\s?[A-Z]*\s?[A-Z]*)$/i, // 英文姓名校验
    regexp_captcha: /^\d{6}$/, // 验证码校验
    car_plate_number: /^[\u4e00-\u9fa5]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9\u4e00-\u9fa5]{1}$/i, // 车牌号校验,历史数据有小写
    regexp_car_vin: /^[A-HJ-NPR-Z\d]{17}$/i, // 车架号
    regexp_car_vin7: /^[A-HJ-NPR-Z\d]{7}$/, // 车架号后七位
    regexp_car_mileage: /^[1-9]\d{0,6}$/, // 里程
    regexp_coupon_code: /^\d{12}$/, // 优惠券或礼品卡
    regexp_coupon_type: /^1(1|0)[A-HJ-NP-Z\d]{10}$/, // 优惠券类型
    regexp_gift_type: /^2(2|0)[A-HJ-NP-Z\d]{10}$/, // 礼品卡类型
    regexp_bank_account: /^\d{8,32}$/, // 银行账号
    regexp_decimals: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/, // 支持两位小数
    regexp_car_transfer_count: /^\d+$/,
    regexp_price: /^\d+\.?\d{0,2}$/, // 价格输入可以是整数可以是带小数，小数点后最多两位
    regexp_order_id: /^[0-9a-zA-Z]{0,50}$/ // 优惠券发放、核销业务单号
  },
  // 键值对的缓存数据~
  keyMap: {
    'CACHE_STORE_ID': 'cache_store_id',
    'CACHE_STORE_STATUS': 'cache_store_status'
  },
  // 判断一个时间是否在指定的时间当中 bt=8:00:00,et=20:00:00,rt=2016-11-11 9:23:23
  timeInBettwen(bt, et, rt) {
    let placeholder = '2016-11-11 '
    let reg = /[^\s]*\s?([^.]*)\.?.*/
    let aRt = rt.replace(reg, '$1').split(':')
    let nRt = aRt[0] * 3600 + aRt[1] * 60 + aRt[2] * 1

    let aBt = (placeholder + bt).replace(reg, '$1').split(':')
    let nBt = aBt[0] * 3600 + aBt[1] * 60 + aBt[2] * 1

    let aEt = (placeholder + et).replace(reg, '$1').split(':')
    let nEt = aEt[0] * 3600 + aEt[1] * 60 + aEt[2] * 1
    return nBt <= nRt && nRt <= nEt
  },
  /**
   * 判断两个时间相差多少
   * @param t1 {String/Date} 时间1
   * @param t2 {String/Date} 时间2
   * @param offset {number} 偏差，单位是毫秒
   */
  diffTime(t1, t2, offset) {
    if (typeof t1 === 'string') {
      t1 = new Date(t1.replace(/-/g, '/'))
    }
    if (typeof t2 === 'string') {
      t2 = new Date(t2.replace(/-/g, '/'))
    }
    offset = offset || 0
    let r = t1.getTime() - t2.getTime() - offset
    return r
  },
  /**
   * 得到将来的某个日期
   * @param str 创建订单时间
   * @param days 失效时间
   * @returns {Date}
   */
  getEndTime(str, days) {
    let date = new Date(str.replace(/-/g, '/'))
    date.setDate(date.getDate() + days)
    return date
  },
  /**
   * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
   * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
   * 例子：
   * formatTime(new Date(), 'yyyy-MM-dd hh:mm:ss.S') ==> 2006-07-02 08:09:04.423
   * formatTime(new Date(), 'yyyy-M-d h:m:s.S')      ==> 2006-7-2 8:9:4.18
   * 参照：http://www.cnblogs.com/zhangpengshou/archive/2012/07/19/2599053.html
   */
  formatTime(time, fmt) {
    if (typeof time !== 'string' && typeof time !== 'number' && !(time instanceof Date)) {
      return ''
    }
    if (typeof time === 'number') {
      time = new Date(time)
    }
    if (typeof time === 'string') {
      time = time.replace(/-/g, '/')
      time = new Date(time)
    }
    let o = {
      'M+': time.getMonth() + 1, // 月份
      'd+': time.getDate(), // 日
      'h+': time.getHours(), // 小时
      'm+': time.getMinutes(), // 分
      's+': time.getSeconds(), // 秒
      'q+': Math.floor((time.getMonth() + 3) / 3), // 季度
      'S': time.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  },
  /**
   * 清理对象中的无效字符串
   * @param {object} obj 需要清理的无效字段的obj
   * ""(空字符串)、数字 0 将判断为有效
   * 以下字段值会判断为无效：null、NaN、undefined。
   */
  clearNullProp(obj) {
    const _this = this
    // 复制一份避免影响原数据
    const _obj = cloneDeep(obj)
    forIn(_obj, (val, key) => {
      if (!val && val !== 0 && val !== false) {
        delete _obj[key]
      }

      if (_obj[key] instanceof Object) {
        _obj[key] = _this.clearNullProp(_obj[key])
        // 经过上面递归处理完，可能会出现 follow: {} 的情况，所以在回溯时，将 follow 也一并干掉
        if (!Object.keys(_obj[key]).length) {
          delete _obj[key]
        }
      }
    })
    return _obj
  },
  getLastMonth(date) {
    let year = +date.split('-')[0]
    let lastMonty = +date.split('-')[1] - 1
    let day = date.split('-')[2]
    if (lastMonty === 0) {
      year = year - 1
      lastMonty = 12
    } else if (lastMonty > 0 && lastMonty < 10) {
      lastMonty = `0${lastMonty}`
    }
    if (day) {
      return `${year}-${lastMonty}-${day}`
    } else {
      return `${year}-${lastMonty}`
    }
  },
  getYesterday(date) {
    const dateVal = new Date(date)
    return this.formatTime(dateVal.setDate(dateVal.getDate() - 1), 'yyyy-MM-dd')
  },
  /**
   * @param {Object} param 将要转为URL参数字符串的对象
   * @param {Object} key URL参数字符串的前缀
   * @param {Boolean} encode true/false 是否进行URL编码,默认为true
   * @source http://www.tuicool.com/articles/uaIr2mj
   * return URL参数字符串
   */
  urlEncode(param, key, encode) {
    if (param == null) {
      return ''
    }
    if (!key) {
      key = ''
    }
    var paramStr = ''
    var t = typeof (param)
    if (t === 'string' || t === 'number' || t === 'boolean') {
      paramStr += '&' + key + '=' + ((encode === null || encode) ? window.encodeURIComponent(param) : param)
    } else {
      for (var i in param) {
        var k = key === null ? i : key + (param instanceof Array ? '-' + i + '-' : i)
        paramStr += this.urlEncode(param[i], k, encode)
      }
    }
    return paramStr
  },
  /**
   * 判断即时时间
   * @param endtime 结束时间
   * @param target 目标对象
   * @param callback
   * @returns {string}
   */
  loopTime(endtime, callback) {
    let nowtime = new Date()
    if (nowtime.getTime() < endtime.getTime()) {
      setTimeout(() => {
        this.loopTime(endtime, callback)
      }, 1000)
    }
  },
  /**
   * 原生ajax请求
   * @param mode 请求方式get/post
   * @param url 请求接口
   * @param data 请求参数
   * @param callback 请求回调
   */
  sendAjax(mode, url, data, callback1, callback2) {
    let csrftoken = cookie.getCookie('csrf-token')
    // 因为只在移动端则没有做IE拦截
    let request = new window.XMLHttpRequest()
    // 2. 设置回调监听
    request.onreadystatechange = function() {
      if (request.readyState === 4 && request.status === 200) {
        let res = JSON.parse(request.responseText)
        if (res.code === 0) {
          callback1()
        }
      } else if (request.readyState === 4 && request.status === 401) {
        let res = JSON.parse(request.responseText)
        if (res.code === 402) {
          callback2()
        }
      }
    }
    request.open(mode, url)
    // 4. 设置请求头, 对请求体数据进行编码处理
    request.setRequestHeader('Accept', 'application/json, text/plain, */*')
    request.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
    request.setRequestHeader('Content-type', 'application/json;charset=utf-8', true)
    request.setRequestHeader('channelType', 'wx')
    request.setRequestHeader('X-CSRF-Token', csrftoken)
    // 5. 发请求
    request.send(data)
  },

  // 修改title
  changeTitle (title) {
    document.title = title
    // 暂时删除针对微信的document.title兼容处理的问题,等测试完毕,看最后兼容性问题
    // 这里添加iframe存在每次切换页面都会APP.vue执行生命周期
    // let iframe = document.createElement('iframe')
    // iframe.src = '/static/favicon.ico'
    // iframe.style.display = 'none'
    // iframe.style.width = '1px'
    // iframe.style.height = '1px'
    // iframe.onload = function () {
    //   setTimeout(function () {
    //     document.body.removeChild(iframe)
    //   }, 0)
    // }
    // document.body.appendChild(iframe)
  },

  // 浮点数相乘计算
  accMul (arg1, arg2) {
    var m = 0
    var s1 = arg1.toString()
    var s2 = arg2.toString()
    try {
      m += s1.split('.')[1].length
    } catch (e) {
    }
    try {
      m += s2.split('.')[1].length
    } catch (e) {
    }
    return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
  },
  /**
   * 判断数据类型
   * @param [String] type 数据预期的类型
   * @param [String/Array/Object/Function/Null/Bollean/Number] data 要判断的值
   */
  isType (type, data) {
    let str = `[object ${type}]`
    return Object.prototype.toString.call(data) === str
  },
  /**
   * 计算字符串字符长度
   * 中文长度计算为 2
   * 英文长度计算为 1
   * @param {*} str 需要计算的字符串
   */
  getByteLen(str) {
    if (str == null) return 0
    if (typeof str !== 'string') {
      str += ''
    }
    return str.replace(/[^\x00-\xff]/g, '01').length // eslint-disable-line
  },
  /**
   * 针对养修预约模块中出现大量形如 2018-12-02 09:00 要展示成 2018-12-02 09:00 -- 09：30
   * @param timeStr 2018-12-02 09:00 || 09:00
   * @returns {string} 2018-12-02 09:00 -- 09：30 || 09:00 -- 09：30
   */
  addHalfHour(timeStr) {
    if (!timeStr || !timeStr.indexOf(':')) {
      return timeStr
    }
    const arr = timeStr.split(':')
    const toTen = (num) => {
      return num < 10 ? `0${num}` : `${num}`
    }
    const hour = arr[0].length === 2 ? arr[0] : arr[0].substr(11)
    const halfHourLater = +arr[1] >= 30 ? `${toTen(~~hour + 1)}:00` : `${hour}:30`
    return `${timeStr} - ${halfHourLater.length <= 5 ? halfHourLater : halfHourLater.substr(11)}`
  },
  /**
   * 通用调出 toast 的方法
   * @param msg
   * @param type
   */
  showToast(msg, type = 'text') {
    if (!msg) return
    Vue.$cvux.toast.show({
      type,
      text: msg
    })
  },
  downloadImage (src, name) {
    const image = new Image()
    // 解决跨域 canvas 污染问题
    image.setAttribute('crossOrigin', 'anonymous')
    image.onload = function () {
      const canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      const context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, image.width, image.height)
      const url = canvas.toDataURL('image/png')
      const a = document.createElement('a')
      const event = new MouseEvent('click')
      a.download = name || '图片'
      a.href = url
      a.dispatchEvent(event)
    }
    image.src = src
  },
  /**
   * 判断number是不是为空
   *
   * @param {*} val
   * @returns
   */
  isNumberEmpty(val) {
    return val !== 0 && !val
  },
  // 这里都是取整数
  wanToFen(val, normal = '') {
    return /^\d+$/.test(`${val}`) ? val * 1000000 : normal
  },
  // 这里取得是整数,所以直接用Math.floor 如果将来要取小数点,那么需要对toFixed做兼容处理
  fenToWan(val, normal = '') {
    return /^\d+$/.test(`${val}`) ? Math.floor(val / 1000000) : normal
  },
  // 获取设备类型
  getDeviceType() {
    if (/Android/.test(window.navigator.userAgent)) {
      return 'Android'
    }
    const platform = window.navigator.platform
    if (['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'].includes(platform)) return 'Mac OS'
    if (['Win32', 'Win64', 'Windows', 'WinCE'].includes(platform)) return 'Windows'
    if (['iPhone', 'iPad', 'iPod'].includes(platform)) return 'IOS'
    return 'unknown'
  }
}
